var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "sport-bracket-sl",
  "use": "sport-bracket-sl-usage",
  "viewBox": "17.42 15.83 34.83 44.33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"17.42 15.83 34.83 44.33\" id=\"sport-bracket-sl\"><path d=\"M52.25 60.167v-6.334h-7.917V47.5h7.917v-6.333H38V47.5h-6.333v-19H38v6.333h14.25V28.5h-7.917v-6.333h7.917v-6.334H38v6.334H25.333v12.666h-7.916v6.334h7.916v12.666H38v6.334h14.25Z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id